import type CalendarModuleStore from './schema/CalendarModuleStore';
import { DEFAULT_CALENDAR_VIEW_TYPE } from 'owa-calendar-view-type';
import { createStore } from 'satcheljs';

const getStore = createStore<CalendarModuleStore>('calendarModuleStore', {
    selectedViewType: DEFAULT_CALENDAR_VIEW_TYPE,
});

export default getStore;
